/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ToolbarNavigationPatient_EmbedPatient = {
    readonly _id: string;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_EmbedNode" | "TypographyNodeName_EmbedNode" | "TypographyNodeDob_EmbedNode">;
    readonly " $refType": "ToolbarNavigationPatient_EmbedPatient";
};
export type ToolbarNavigationPatient_EmbedPatient$data = ToolbarNavigationPatient_EmbedPatient;
export type ToolbarNavigationPatient_EmbedPatient$key = {
    readonly " $data"?: ToolbarNavigationPatient_EmbedPatient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ToolbarNavigationPatient_EmbedPatient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToolbarNavigationPatient_EmbedPatient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_EmbedNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyNodeName_EmbedNode"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyNodeDob_EmbedNode"
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = '404b2b26fe852ba8a1fadd03434b18d3';
export default node;
